import { useTranslation } from 'react-i18next';
import { FacebookPageAnalyticsPostPayload, FacebookPageAnalyticsPostsByDatePayload } from '@anytag/graphql';
import { PostModal, PostModalProps } from '../shared';

export interface FacebookPostInDateDetailsModalProps
  extends Pick<PostModalProps<FacebookPageAnalyticsPostPayload>, 'paramKey'> {
  data: FacebookPageAnalyticsPostsByDatePayload | null;
}

export const FacebookPostInDateDetailsModal = ({ data, paramKey }: FacebookPostInDateDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={data?.posts || []} paramKey={paramKey}>
      {({ selectedPost }) => (
        <>
          <PostModal.Title>{t('Post Detail')}</PostModal.Title>
          <PostModal.DetailsTemplate
            data={{
              socialMedia: 'FACEBOOK',
              caption: selectedPost.content,
              postUrl: selectedPost.postUrl,
              postDate: selectedPost.postDate,
              images: selectedPost.image ? [selectedPost.image] : [],
              comments:
                selectedPost.postComments.map((comment) => ({
                  content: comment.content,
                  username: comment.posterName
                })) || [],
              info: {
                name: data?.pageName,
                avatar: data?.avatar,
                followers: data?.followers
              },
              statistics: {
                reactions: selectedPost.reactions,
                comments: selectedPost.comments,
                shares: selectedPost.shares,
                reach: selectedPost.adImpressions
              }
            }}
          />
        </>
      )}
    </PostModal>
  );
};
